import { FundingProduct } from '@frontend/components/agromarket/core/access-control'

export const MFO_PRODUCTS: FundingProduct[] = [FundingProduct.EXPRESS_MFO, FundingProduct.BNPL_POLECREDIT]
